<template>
  <div>
    <payment-share-popup v-model="showSharePopup" :tradeNo="lease.tradeNo" @paid="onPaid" />
    <van-cell-group title="请确认以下信息">
      <van-cell title="月租产品" :value="lease.leaseProductName + ' ' + (lease.leaseProductPriceName || '')"  value-class="value-class"/>
      <van-cell title="停车场" :value="lease.parkingLotName"  value-class="value-class"/>
      <van-cell v-if="lease.parkAreaId" title="适用区域" :value="lease.parkAreaName"  value-class="value-class"/>
      <van-cell v-if="lease.parkingSpotId" title="车位" :value="lease.parkingSpotName"  value-class="value-class"/>
      <van-cell title="车牌号" :value="lease.plateNumber" />
      <van-cell title="月租价格" :value="lease.leaseProductPrice+'元/月'" />
      <van-cell title="有效期" :value="expiredTime" value-class="value-class"/>
      <van-cell v-show="lease.usedLeasePricePackage" title="优惠" :value="lease.leaseProductPricePackageDesc" />
      <van-cell title="应支付">
        <span><strong style="font-size:24px; color: red">{{lease.totalCharge}}</strong> 元</span>
      </van-cell>
    </van-cell-group>
    <div class="tips">{{lease.note}}</div>
    <br />
    <van-goods-action>
      <van-goods-action-icon icon="cross" text="取消" @click="onCancel"/>
      <van-goods-action-button type="warning" @click="payForFriend" :disabled="loading || lease.totalCharge <= 0" text="好友代付" />
      <van-goods-action-button type="danger" @click="pay" :disabled="loading">支付 ({{timeout|duration}})</van-goods-action-button>
    </van-goods-action>
  </div>
</template>
<script>
import {  Button, Cell, CellGroup, GoodsAction, GoodsActionButton, GoodsActionIcon, Tag} from 'vant';
import qs from 'query-string';
import { router } from '../router';
import dayjs from 'dayjs';
import PaymentSharePopup from '../components/PaymentSharePopup.vue';

export default {
  components: {
    [Button.name] : Button,
    [Tag.name] : Tag,
    [CellGroup.name] : CellGroup,
    [Cell.name] : Cell,
    [GoodsAction.name] : GoodsAction,
    [GoodsActionButton.name] : GoodsActionButton,
    [GoodsActionIcon.name] : GoodsActionIcon,
    'payment-share-popup' : PaymentSharePopup
  },
  data() {
    return {
      loading : false,
      lease: {},
      timeout: 0,
      interval: null,
      showSharePopup: false
    };
  },
  mounted(){
    const {paid} = qs.parse(location.search);
    if (paid == 'true') {
      router.push('/lease_cards')
    } else {
      this.loadLease();
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    async loadLease(){
      const {parkingLotId} = qs.parse(location.search);
      if (parkingLotId) {
        this.lease = await this.$http.get('/lease/Lease_register_info',  {parkingLotId});
        if (this.lease && this.lease.stage==1) {
          //生成倒计时
          this.timeout = this.lease.timeout;
          clearInterval(this.interval);
          this.interval = setInterval(()=> {
            this.timeout --;
            if (this.timeout <= 0) {
              clearInterval(this.interval);
              router.push('/lease_cards');
            }
          }, 1000);
        } else {
          router.push('/lease_card_register?parkingLotId='+parkingLotId);
        }
      }
    },
    onPaid() {
      router.push('/lease_cards');
    },
    onCancel(){
      this.$http.post('/lease/cancel_register', {parkingLotId : this.lease.parkingLotId});
      router.push('/lease_cards');
      this.$wechat.sdk(function(wechat){
        wechat.closeWindow();
      });
    },
    async pay(){
      this.loading = true;
      try {
        const callback = window.location.pathname + window.location.search;
        router.push('/payment?tradeNo='+this.lease.tradeNo+'&callback=' + encodeURIComponent(callback));
      } finally {
        this.loading = false;
      }
    },
    async payForFriend() {
      this.showSharePopup = true;
    }
  },
  computed: {
    expiredTime() {
      return dayjs(this.lease.startDate).format('YYYY年M月D日') + ' - ' + dayjs(this.lease.endDate).add(-1, 'day').format('YYYY年M月D日')
    },
    startTime() {
      return ''
    }
  }
};
</script>

<style lang="less" scoped>
  .tips {
    color: gray;
    margin: 10px;
    font-size: 13px;
  }
  .value-class{
    flex: 4;
  }
</style>